<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img src="@/assets/black-condensen-white-bg.png" class="c-avatar-img " />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Settings</strong>
    </CDropdownHeader>
    <CDropdownItem @click.prevent="$router.push({ name: 'general-settings' })">
      <CIcon name="cil-settings" /> Settings
    </CDropdownItem>
    <CDropdownDivider />
    <CDropdownItem @click="Logout">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { handleUserLoginLogOutAction, removePageModal } from "@/helpers/Helpers";

export default {
  name: 'TheHeaderDropdownAccnt',
  data() {
    return {
      itemsCount: 42
    }
  },
  methods: {
    async Logout() {
      removePageModal();
      await handleUserLoginLogOutAction('hardLogout')
    }
  }
}
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>